/**
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */

import Vue from 'vue';

import CEUtils from '@cekit/ce-utils';
import { getUserInfo, login, logout } from 'resfull/private/user';
import { getSaasTenantInfo, getSaasLoginUser, getSaasLogout, getToken } from 'resfull/npgw/saas';
import { getPermissionListByUserId } from 'resfull/npgw/pcp';
// import { isOpenSsl } from 'resfull/npgw/cms/ssl';
import { removeAccessToken, removeAccessInstance, setAccessToken, setAccessInstance, set, remove } from '@/utils/access_token';
// import { resetRouter } from '../../router/router-reset';
import settings from 'settings';
import { getByIdAndMemberCode } from 'resfull/npgw/newDomain';
import { getAllTenantAppListByTenantId } from 'resfull/product/product';
import { getLocalEnv } from '@/utils/tools';
import { TenantInfoFacade, BmTenantInfoFacade } from '@/facade/tenant-info.facade';

const { title, tokenType, visitorAuths, visitorUser, accessTestInstance, loginInterceptionType, userDataKey } = settings;

const state = () => ({
    loginUrl: '', // 拦截登录页面值
    accessToken: '',
    accessInstance: '',
    tenantId: '',
    username: '',
    userId: '',
    avatar: '',
    userdata: {}, // API:/local/cms/getLoginUser数据项的user
    permissions: [],
    appList: [],
    tenantInfo: {},
    searchEngines:true,
});
const getters = {
    loginUrl: state => state.loginUrl,
    accessToken: state => state.accessToken,
    accessInstance: state => state.accessInstance,
    username: state => state.username,
    userId: state => state.userId,
    avatar: state => state.avatar,
    userdata: state => state.userdata,
    permissions: state => state.permissions,
    tenantId: state => state.tenantId,
    appList: state => state.appList,
    tenantInfo: state => state.tenantInfo,
    tenantJson: state => state.tenantInfo,
    searchEngines: state => state.searchEngines,
};
const mutations = {
    setLoginUrl(state, loginUrl) {
        state.loginUrl = loginUrl;
        set('loginUrl', loginUrl);
    },
    setAccessToken(state, accessToken) {
        state.accessToken = accessToken;
        // token保存至loaclstorage
        setAccessToken(accessToken);
    },
    setAccessInstance(state, accessInstance) {
        state.accessInstance = accessInstance;
        // Instance保存至loaclstorage
        setAccessInstance(accessInstance);
    },
    setTenantId(state, tenantId) {
        state.tenanId = tenantId;
    },
    setUsername(state, username) {
        state.username = username;
    },
    setUserId(state, userId) {
        state.userId = userId;
    },
    setAvatar(state, avatar) {
        state.avatar = avatar;
    },
    setUserdata(state, userdata) {
        state.userdata = Object.assign(state.userdata, userdata);
        set(userDataKey, state.userdata);
    },
    setPermissions(state, permissions) {
        state.permissions = permissions;
    },
    setAppList(state, appList) {
        state.appList = appList;
    },
    setTenantInfo(state, tenantInfo) {
        state.tenantInfo = tenantInfo;
    },
    setTenantJson(state, tenantJson) {
        state.tenantJson = tenantJson
    },
    setSearchEngines(state,searchEngines){
        state.searchEngines = searchEngines;
    }
};
const actions = {
    setSearchEngines({ commit }, tenantJson){
        let showGoogleAndYandexCode = ['digital-portal-ITAI','digital-portal-global-XN','digital-portal-group', 'digital-portal-global-exclusive', 'digital-portal-global', 'digital-portal-lawfirm', 'digital-portal-global-FTS', 'digital-portal-cross-border'];
        let reg = /\-ADV$/
        if (!showGoogleAndYandexCode.filter(r => r == tenantJson.templateCode).length && !reg.test(tenantJson.templateCode)) {
            commit('setSearchEngines', true)
        }else{
            commit('setSearchEngines', false)
        }        
    },
    setTenantJson({ commit }, tenantJson) {
        commit('setTenantJson', tenantJson)
    },
    setPermissions({ commit }, permissions) {
        commit('setPermissions', permissions);
    },
    // 私有化登录
    async loginPrivate({ commit }, userInfo) {
        const { data } = await login(userInfo);
        const accessToken = data[tokenType];
        if (accessToken) {
            commit('setAccessToken', accessToken);
            const hour = new Date().getHours();
            const thisTime = hour < 8 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 18 ? '下午好' : '晚上好';
            Vue.prototype.$ce.baseNotify(`欢迎登录${title}`, `${thisTime}！`);
        } else {
            Vue.prototype.$ce.baseMessage(`登录接口异常，未正确返回${tokenType}...`, 'error');
        }
    },
    async setAppList({ commit }) {
        let isNumberPortal = sessionStorage.getItem('numberPortal-info')
        if (isNumberPortal) {
            return false
        }
        const res = await getAllTenantAppListByTenantId();
        let appList = res.data || [];
        commit('setAppList', appList);
    },
    /**
     * Saas单点登录验证
     * @param {any} param0
     */
    async loginSaas({ commit, dispatch }) {
        // 登陆之前 先清楚所有localstorage
        localStorage.clear();
        // 解决清楚之后的logo问题
        localStorage.setItem(
            'ce-center-layoutConfig',
            JSON.stringify({
                isShowLogo: true,
                layoutSet: 'ce',
            }),
        );
        //环境变量
        Vue.prototype.$baseUrlImg = 'https://pre-omo-oss-image.thefastimg.com/';
        Vue.prototype.$baseUrlVideo = 'https://pre-omo-oss-video.thefastvideo.com/';
        Vue.prototype.$baseUrlFile = 'https://pre-omo-oss-file.thefastfile.com/';
        Vue.prototype.$baseUrlUpolad = 'https://pre-omo-gateway.thefastimg.com';
        Vue.prototype.$sopHost = 'http://test-sop.ceboss.cn';
        Vue.prototype.$Permission = "https://pre-omo-oss-encryption.thefastfile.com";

        // 默认测试后缀
        Vue.prototype.$bmSuffix = 'p.make.test-dcloud.portal1.portal.thefastmake.com';
        Vue.prototype.$key = 'c57a96fd-cfa8-4d4c-9863-d381ccb34038';
        // Vue.prototype.$newkey = '9a9c19c9-8c21-45c1-bdfb-fa2e28a2648f';
        // 取得本地环境
        Vue.prototype.$env = getLocalEnv();
        console.log('current: env:', Vue.prototype.$env);

        if (Vue.prototype.$env == 'prod') {
            Vue.prototype.$baseUrlImg = 'https://omo-oss-image.thefastimg.com/';
            Vue.prototype.$baseUrlVideo = 'https://omo-oss-video110.thefastvideo.com/';
            Vue.prototype.$baseUrlFile = 'https://omo-oss-file110.thefastfile.com/';
            Vue.prototype.$baseUrlUpolad = 'https://omo-gateway.thefastimg.com';
            Vue.prototype.$key = 'cadabd56-3a6c-4b5e-bc67-d38f24d84143';
            Vue.prototype.$sopHost = 'http://sop.ceboss.cn';
            Vue.prototype.$bmSuffix = 'p.make.dcloud.portal1.portal.thefastmake.com';
            Vue.prototype.$Permission = 'https://omo-oss-encryption.thefastfile.com';

            Vue.prototype.$newkey = '9a9c19c9-8c21-45c1-bdfb-fa2e28a2648f';
        } else if (Vue.prototype.$env == 'pre') {
            Vue.prototype.$bmSuffix = 'p.make.pre-dcloud.portal1.portal.thefastmake.com';
        }

        // TODO WQ 这个地方可以优化
        // 没必要每次请求都获取环境信息
        // let res = await getEnv({});
        // if (res && res.status == 200) {
        //     console.log(res, 'getEnv');
        //     //生产prod  预发布pre 测试test
        //     console.log(res.data.env, 'res.data.env');
        //     // 检查环境信息
        //     Vue.prototype.$env = res.data.env;
        //     if (res.data.env == 'prod') {
        //         Vue.prototype.$baseUrlImg = 'https://omo-oss-image.thefastimg.com/';
        //         Vue.prototype.$baseUrlVideo = 'https://omo-oss-video.thefastvideo.com/';
        //         Vue.prototype.$baseUrlFile = 'https://omo-oss-file.thefastfile.com';
        //         Vue.prototype.$baseUrlUpolad = 'https://omo-gateway.thefastimg.com';
        //         Vue.prototype.$key = 'cadabd56-3a6c-4b5e-bc67-d38f24d84143';
        //         Vue.prototype.$sopHost = 'http://sop.ceboss.cn';
        //         Vue.prototype.$bmSuffix = 'p.make.dcloud.portal1.portal.thefastmake.com';
        //     } else if (res.data.env == 'pre') {
        //         Vue.prototype.$bmSuffix = 'p.make.pre-dcloud.portal1.portal.thefastmake.com';
        //     }
        // }

        const data = await getSaasTenantInfo();
        if (data && data.status === 999) {
            // console.log(data, 'user.js getSaasTenantInfo');
            // 强制发送请求，拿去cookie，此方法不知会不会失效。暂时解决2次登录问题
            // 2021-05-25 解决非法get请求方法 解决方式：注释掉sendUrl 修改为locaction跳转
            // const backUrl = data.location + encodeURIComponent('&backurl=' + encodeURIComponent(`${CEUtils.locat().origin}${publicPath}?${tokenType}=${getAccessInstance()}`));
            // 强制发送请求，拿去cookie，此方法不知会不会失效。暂时解决2次登录问题
            // backUrl &&
            //     // 需要注册 import { sendUrl } from 'resfull/npgw/saas';
            //     sendUrl(backUrl).then(() => {
            //         /* IFTRUE_isProd */
            //         // 测试环境会造成死循环，所以测试环境不启用代码
            //         Vue.prototype.$ce.baseNotify('登录中...', '消息', 'info');
            //         setTimeout(() => {
            //             location.href = publicPath + '/';
            //         }, 3000);
            //         /* FITRUE_isProd */
            //     });
            // 2021年06月05日 段朝骞确定跳转的地方不会是json的地址，导致登录失败，如果再出现打开上面注释，关闭低下
            // 还有可能导致无限刷新的问题，999的状态;可以考虑判定存储刷新次数超过3次停止刷新，但无法解决登录失效重复刷新问题
            // window.location.href = backUrl;
        } else if (data && data.status === 200) {
            // 修改setAccessToken
            let _instance = data.data.instance;
            /* IFTRUE_isMock */
            // 代替 IFTRUE_isMock 宏的功能，直接通过环境变量控制
            // if (import.meta.env.VITE_ENV_CONFIG === 'dev') {
            //     _instance = accessTestInstance;
            // }
            /* FITRUE_isMock */
            //获取token
            getToken({}).then(res => {
                sessionStorage.setItem('TOKEN', res.data.token);
                localStorage.setItem('TOKEN', res.data.token);
                commit('setAccessToken', res.data.token);

                // 数字门户
                // dispatch('numberPortal/setToken', res.data.token)

            });
            //commit('setAccessToken', _instance);
            commit('setAccessInstance', _instance);
            commit('setTenantId', data.data.id);
            commit('setTenantInfo', data.data);
            let userInfo = {
                tenantId: data.data.id,
                custId: data.data.custId,
            };
            commit('setUserdata', userInfo);
            // 域名管理用到
            // sessionStorage.setItem('thyTenantInfo', JSON.stringify(data.data));
            TenantInfoFacade.set(data.data);
            BmTenantInfoFacade.set(data.data);
            Vue.prototype.$http = data.data.domainSSL == 1 ? 'https://' : 'http://'
            if( sessionStorage.getItem('invoke-form') !== 'managePanel' ) {//老门户iframe页面不需要获取动态菜单/权限
                dispatch('setAppList');
            }

            /**
             *  cms 有功能用到这块
             *  // 选择链接协议 - isOpenSsl:true 用https  false用http
                // 1.判断设计期 或 运营期
                // 2.设计期时 用http
                // 3.运营期时 调接判断 http 还是https
             */
            //运营期
            if (data.data.productMode) {
                // let resultSSl = await isOpenSsl();
                // if (resultSSl) {
                //     sessionStorage.setItem('linkProtocol', resultSSl.isOpenSsl ? 'https://' : 'http://');
                //     Vue.prototype.$linkProtocol = resultSSl.isOpenSsl ? 'https://' : 'http://';
                // } else {
                sessionStorage.setItem('linkProtocol', 'http://');
                Vue.prototype.$linkProtocol = 'http://';
                // }
            } else {
                //设计期
                sessionStorage.setItem('linkProtocol', 'http://');
                Vue.prototype.$linkProtocol = 'http://';
            }
            return true;
        }
        return false;
    },
    // 私有化获取用户信息
    async getPrivateUserInfo({ commit, state }) {
        const { data } = await getUserInfo(state.accessToken);
        if (!data) {
            Vue.prototype.$ce.baseMessage('验证失败，请重新登录...', 'error');
            return false;
        }
        let { permissions, username, userId } = data;
        if (permissions && username) {
            commit('setPermissions', permissions);
            commit('setUsername', username);
            commit('setUserId', userId);
            commit('setAvatar', 'el-icon-s-custom');
            return permissions;
        } else {
            if (!sessionStorage.getItem('TOKEN')) {
                Vue.prototype.$ce.baseMessage('用户信息接口异常', 'error');
                return false;
            }
        }
    },
    // Saas化获取用户信息
    async getSaasUserInfo({ commit }) {
        // 获取登录用户信息接口
        const { data: dataUserInfo, status } = await getSaasLoginUser();

        if (!status || status !== 200) {
            // 注销登录状态
            // await dispatch('logout');
            return [];
        }
        // 数字门户
        // sessionStorage.setItem('numberPortal-userinfo', JSON.stringify(dataUserInfo))
        const { tenantId, user: userInfo } = dataUserInfo;

        sessionStorage.setItem('tenantIds', tenantId)
        //兼容老门户社交媒体
        const { pathname } = CEUtils.locat()
        let invokeForm
        if(pathname.includes('/manageP/sns/')) {
            invokeForm = 'managePanel';
        }
        if( sessionStorage.getItem('invoke-form') === 'managePanel' || (invokeForm=== 'managePanel') ) return []
        let resultArr = await Promise.all([
            getByIdAndMemberCode({ targetTenantId: tenantId, memberCode: userInfo.memberCode }),
            getPermissionListByUserId({ tenantId: tenantId, userId: userInfo.memberCode })
        ]);

        // 获取当前登录账号的角色 解决切换网站角色不变化
        const { data: curUserinfo } = resultArr[0];
        console.log(curUserinfo, '当前登录账号的角色');
        if (curUserinfo && curUserinfo.roles && curUserinfo.roles.length > 0) {
            let _arr = [];
            curUserinfo.roles.map(v => {
                _arr.push(v.id);
            });
            userInfo.roles = JSON.stringify(_arr);
            console.log(_arr, userInfo, '替换登陆接口返回的roles');
        } else {
            userInfo.roles = null;
        }
        // const menuList = await getMenuListByTenantId({ tenantId: userInfo.tenantId });
        /* IFTRUE_isMock */
        // userInfo.memberCode = 'SUPER_ADMIN_VIRTUAL';
        /* FITRUE_isMock */

        // 获得登录用户的权限接口
        const auths = resultArr[1];
        // 获得权限
        const { menuCode: permissions } = auths.data;
        // 获得用户username, 头像类型
        const { name: username, isSuper, userId } = userInfo;

        if (permissions && username) {
            commit('setPermissions', permissions);
            commit('setUsername', username);
            commit('setUserId', userId);
            // isSuper 0 超级管理员，1 属于普通管理员
            commit('setAvatar', isSuper === '0' ? 'el-icon-s-custom' : 'el-icon-user-solid');
            // API:/local/cms/getLoginUser数据项的user存储
            // 存储租户id
            commit('setTenantId', tenantId);
            userInfo['tenantId'] = tenantId;
            // 这个地方会将数据写入到 sessionStorage ce-center-ce-user-info 中
            commit('setUserdata', userInfo);
            return permissions;
        } else {
            if (!sessionStorage.getItem('TOKEN')) {
                Vue.prototype.$ce.baseMessage('用户信息接口异常', 'error');
                return [];
            }
        }
    },
    // 访客用户
    getVisitor({ commit }) {
        // 访客用户
        let token = 'VISTOR_' + new Date().getTime();
        commit('setAccessToken', token);
        commit('setPermissions', visitorAuths);
        commit('setUsername', visitorUser.username);
        commit('setAvatar', visitorUser.avatar);
        return visitorAuths;
    },
    async logout({ dispatch }) {
        if (loginInterceptionType === 'saas') {
            await getSaasLogout({ bmloginout: 'yes' });
        } else {
            await logout(state.accessToken);
        }
        await dispatch('resetAccessToken');
        let router = await import('../../router/router-reset');
        await router.resetRouter();
    },
    async saasLogout({ dispatch }, type) {
        console.log(dispatch, type, 'thy logout')
        const logout = await getSaasLogout({ bmloginout: 'yes' });
        await dispatch('resetAccessToken');
        // 兼容处理 
        if (type != '2024') {
            let router = await import('../../router/router-reset');
            await router.resetRouter();
        }
        return logout;
    },
    resetAccessToken({ commit }) {
        commit('setPermissions', []);
        commit('setAccessToken', '');
        commit('setAccessInstance', '');
        commit('setUserdata', {});
        commit('setPermissions', []);
        commit('setUsername', '');
        commit('setUserId', '');
        commit('setAvatar', '');
        commit('setTenantInfo', {});
        commit('setTenantJson', {})
        commit('setSearchEngines',true)
        remove(userDataKey);
        removeAccessToken();
        removeAccessInstance();
    },
    setUserdata({ commit }, userInfo ) {
        commit('setUserdata', userInfo);
    },
    setUsername({ commit }, Username ) {
        commit('setUsername', Username);
    }
};
export default { state, getters, mutations, actions, };
